export const urlBase = `${process.env.REACT_APP_URL_BASE_SCHEDULE}`;
